import React from 'react';
import { ButtonTertiary } from '@americanexpress/dls-react';
import styles from './showSubcategory.module.scss';
import LiteralsService from 'src/services/literals/LiteralsService';
import { GlyphDown, GlyphUp } from '@americanexpress/dls-icons';
import { DLSSize } from 'src/types/dls-size.enum';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import Typography from 'src/components/typography/Typography';
import colors from 'src/styles/colors.module.scss';
import Selectors from 'src/utils/selectors';

interface ShowSubcategoryButtonProps {
    onClick?: () => void;
    className?: string;
    id?: string;
    'aria-controls'?: string;
    showingSubcategories?: boolean;
    'aria-expanded'?: boolean;
    disabled?: boolean;
}

export default function ShowSubcategoryButton({
    showingSubcategories,
    className,
    onClick,
    'aria-expanded': ariaExpanded,
    'aria-controls': ariaControls,
    id,
    disabled
}: ShowSubcategoryButtonProps): JSX.Element {
    if (disabled)
        return (
            <span
                className={styles.showSubcategoryButtonDisabled}
                data-cy={Selectors.SpendSmart.SHOW_SUBCATEGORY_BUTTON_DISABLED}
            >
                <Typography variant={TypographyVariants.BODY} className={colors.disabledStrong}>
                    {LiteralsService.getLiteral('ShowSubcategoryButton.show')}
                </Typography>
                <GlyphDown
                    className={styles.glyphDisabled}
                    size={DLSSize.SMALL}
                    titleId="show-subcategories"
                    title={LiteralsService.getLiteral('ShowSubcategoryButton.show')}
                />
            </span>
        );

    return (
        <ButtonTertiary
            className={`${styles.showSubcategoryButton} ${className}`}
            onClick={onClick}
            aria-expanded={ariaExpanded}
            aria-controls={ariaControls}
            id={id}
            data-cy={Selectors.SpendSmart.SHOW_SUBCATEGORY_BUTTON}
        >
            {LiteralsService.getLiteral(`ShowSubcategoryButton.${showingSubcategories ? 'hide' : 'show'}`)}
            {showingSubcategories ? (
                <GlyphUp
                    className={styles.glyph}
                    size={DLSSize.SMALL}
                    titleId="hide-subcategories"
                    title={LiteralsService.getLiteral('ShowSubcategoryButton.hide')}
                />
            ) : (
                <GlyphDown
                    className={styles.glyph}
                    size={DLSSize.SMALL}
                    titleId="show-subcategories"
                    title={LiteralsService.getLiteral('ShowSubcategoryButton.show')}
                />
            )}
        </ButtonTertiary>
    );
}
